import { motion } from "framer-motion";
import { IMAGES } from "@/lib/images";
import { Reveal } from "./Reveal";

const STATS = [
  { value: "12+", label: "Years Braiding" },
  { value: "500+", label: "Crowns Created" },
  { value: "75+", label: "Artists Trained" },
];

export const Instructor = () => (
  <section id="instructor" data-testid="instructor-section" className="bg-cream py-24 sm:py-32 relative overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-5 relative">
        <Reveal>
          <div className="relative arch overflow-hidden border-4 border-wine/10 aspect-[3/4] max-w-md">
            <img src={IMAGES.instructor} alt="Lead instructor" className="h-full w-full object-cover" />
          </div>
        </Reveal>
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="absolute -right-2 sm:right-6 bottom-8 bg-wine text-cream rounded-2xl px-6 py-4 shadow-2xl"
        >
          <div className="font-display text-2xl">Kim Cay</div>
          <div className="font-mono text-[9px] uppercase tracking-[0.2em] text-gold mt-1">
            Founder & Lead Educator
          </div>
        </motion.div>
      </div>

      <div className="lg:col-span-7">
        <Reveal>
          <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-wine/50">
            Meet Your Instructor
          </span>
          <h2 className="font-display font-light text-wine text-5xl sm:text-6xl leading-[1] mt-5">
            Trained by the hands that <span className="italic text-gold">built the crown.</span>
          </h2>
          <p className="text-wine/70 mt-6 text-lg leading-relaxed max-w-2xl">
            Crowned™ Pro is led by Master Braider <span className="text-wine font-semibold">Kim Cay</span>,
            whose work has adorned hundreds of everyday kings and queens. Her philosophy is simple —
            technique is the foundation, but confidence is the crown. Every lesson blends artistry,
            precision, and the business wisdom to build a lasting career.
          </p>
          <blockquote className="mt-8 border-l-2 border-gold pl-6 max-w-2xl">
            <p className="font-display italic text-wine text-2xl sm:text-3xl leading-snug">
              "Learn the skill. Master the technique. The crown is what you carry once both become
              second nature."
            </p>
            <footer className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-wine/50">
              — Kim Cay, Founder
            </footer>
          </blockquote>
          <div className="grid grid-cols-3 gap-6 mt-12 max-w-lg">
            {STATS.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.1}>
                <div className="border-l-2 border-gold pl-4">
                  <div className="font-display text-4xl sm:text-5xl text-wine">{s.value}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-wine/50 mt-1">
                    {s.label}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
